<template>
    <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <defs>
      <polygon id="path-4" points="3.43008246 6.50088143 0.86903611 3.93983509 0 4.8088712 3.43008246 8.23895365 10.8 0.86903611 9.93096389 0"></polygon>
    </defs>
    <g id="Apps" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
      <g id="Dashboard" transform="translate(-862.000000, -438.000000)">
        <g id="Content" transform="translate(128.000000, 120.000000)">
          <g id="Tasks" transform="translate(404.000000, 0.000000)">
            <g id="List" transform="translate(16.000000, 304.000000)">
              <g id="Group" transform="translate(4.928571, 10.000000)">
                <g id="Details" transform="translate(254.571429, 0.000000)">
                  <g id="Atoms/Form/Checkbox/State" transform="translate(52.553571, 2.000000)">
                    <g id="Variables/Icon/Tick" transform="translate(2.400000, 2.400000)">
                      <g id="Group" transform="translate(4.200000, 5.400000)">
                        <mask id="mask-5" fill="white">
                          <use xlink:href="#path-4"></use>
                        </mask>
                        <g id="↳-🎨Color" mask="url(#mask-5)" fill="#FFFFFF">
                          <g transform="translate(-4.200000, -5.400000)" id="Color">
                            <rect x="0" y="0" width="19.2" height="19.2"></rect>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'TickIcon',
};
</script>

<style scoped>

</style>
